var map = {
	"./translation.de.yml": 1176,
	"./translation.en.yml": 1177,
	"./translation.es.yml": 1178,
	"./translation.fr.yml": 1179,
	"./translation.he.yml": 1180,
	"./translation.nl.yml": 1181,
	"./translation.zh-CN.yml": 1182,
	"./translation.zh-TW.yml": 1183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;



//////////////////
// WEBPACK FOOTER
// ./i18n/translations ^\.\/translation\..*\.yml$
// module id = 810
// module chunks = 0